import Index from '@tunnel-components/@pages/supervision/simulator/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/simulator/home/index.ts